export default function getExchangeData(shift, currentUser) {
  if (!shift.exchanges || !shift.exchanges.length) {
    return {
      isSwap: false,
    };
  }

  // with v1 we only support 1 swap but model allows for multiple in the future
  const swap = shift.exchanges.find((exchange) => exchange.offereeShiftId);

  const amIOfferer = Boolean(swap && swap.offerer && swap.offerer.id === currentUser.id);
  const amIOfferee = Boolean(swap && swap.offeree && swap.offeree.id === currentUser.id);

  const isOfferedByMe = amIOfferer && swap.offererShiftId === shift.id; // shift check is needed to avoid dupes in available shifts row
  const isOfferedToMe = amIOfferee && swap.offererShiftId === shift.id;

  return {
    isSwap: Boolean(swap),
    amIOfferer,
    isOfferedByMe,
    amIOfferee,
    isOfferedToMe,
    swap,
  };
}
